/**
 * useIntercompanyMarkerGate — "should this picker mark internal group companies?"
 *
 * Resolve it ONCE in a picker's body and pass the boolean down to every option
 * row. The per-row alternative (dropping {@link IntercompanyBadge} into a
 * `renderItem`) mounts two React Query subscriptions per row — ~50 hook
 * instances for one open dropdown — for a value that cannot differ between rows.
 *
 * Gate: the multi-company "hide-when-single" rule (`useMyCompanies().length > 1`),
 * the same one {@link IntercompanyBadge} and `DocumentCompanyField` apply. It
 * deliberately does NOT consult `useCompanyScoping()`: an organization picker is
 * module-agnostic (one component serves 60+ consumers across every ERP module),
 * and "this counterparty IS one of our own legal entities" is a fact about the
 * organization, not about whether a given module's documents carry a company.
 *
 * See docs/erp/intercompany-design.md.
 */
import { useMyCompanies } from '../users/hooks/useCompanies';

export function useIntercompanyMarkerGate(): boolean {
  const { data } = useMyCompanies();
  return (data?.data.length ?? 0) > 1;
}
